import { Button } from '@/ui/Button'

export interface QuantUnavailableProps {
  message: string
  onRetry: () => void
}

/**
 * The shared "echo-core or the run-bridge is unavailable" panel (spec 037 U4):
 * one truncating sentence and a Retry button, in a fixed-height box so the
 * layout never depends on the message.
 */
export function QuantUnavailable({ message, onRetry }: QuantUnavailableProps) {
  return (
    <div
      role="alert"
      className="flex h-14 min-w-0 items-center gap-3 border border-alert px-4 font-mono text-[12px] text-paper-90"
    >
      <span className="min-w-0 flex-1 truncate" title={message}>
        {message}
      </span>
      <Button variant="secondary" size="sm" onClick={onRetry} className="shrink-0">
        Retry
      </Button>
    </div>
  )
}
